/* eslint-disable prettier/prettier */
import styles from '../../styles/components/common/CoachCard.module.css';

interface Props {
	image: string;
	name: string;
	experience: string;
	gradientColor: string;
}

const CoachCard = ({ image, name, experience, gradientColor }: Props) => {
	return (
		<div className={styles.card}>
			<img src={image} alt={name} className={styles.image} />

			{/* <div className={styles.overlay}> */}
			<div
				className={styles.overlay}
				style={{
					background: `linear-gradient(
            to top,
            ${gradientColor},
            ${gradientColor}B3,
            ${gradientColor}00
        )`,
				}}
			>
				<h4>{name}</h4>
				<p>{experience}</p>
			</div>
		</div>
	);
};

export default CoachCard;
